export default {
  init(){
    console.log('in home init');
  }
}